
import React from "react";
import { AuthButtons } from "./AuthButtons";
import { useAuth } from "@/components/auth/AuthProvider";
import { 
  MobileAuthSection,
  MobileFindHomeSection, 
  MobileShortlistSection, 
  MobileJourneySection,
  MobileResourcesSection,
  MobileCompanySection,
  MobileLinksSection,
  MobileWaitlistCTA
} from "./mobile";
import { GuestSavesIndicator } from "./GuestSavesIndicator";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const { user } = useAuth();

  if (!isOpen) return null;

  return (
    <div className="lg:hidden bg-white border-t shadow-lg fixed top-[72px] left-0 right-0 z-40 max-h-[calc(100vh-72px)] overflow-y-auto">
      <div className="container py-6">
        <div className="space-y-5">
          {/* Authentication section at the top */}
          <div className="mb-4">
            {/* Desktop Nav Auth Buttons - Hidden on Mobile */}
            <div className="hidden">
              <AuthButtons />
            </div>
            
            {/* Guest Saves Indicator for Mobile */}
            <div className="mb-3">
              <GuestSavesIndicator />
            </div>
            
            {/* Mobile Auth Section - Sign in/up or user profile */}
            <MobileAuthSection onClose={onClose} />
          </div>

          {/* Navigation sections */}
          <MobileFindHomeSection onClose={onClose} />
          <MobileShortlistSection onClose={onClose} />
          <MobileJourneySection onClose={onClose} />
          <MobileResourcesSection onClose={onClose} />
          <MobileCompanySection onClose={onClose} />
          <MobileLinksSection onClose={onClose} />

          {/* Waitlist CTA */}
          <MobileWaitlistCTA onClose={onClose} />
        </div>
      </div>
    </div>
  );
}
